import { populate } from 'populate'; import dragonBones from 'pixi-dragonbones';

const raw = {
  className: '',
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: 'ca816ee2-2612-4e37-be37-74c40d43de14',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: 'da9c5f4d-9f68-4f25-89e5-3a0748a11718',
      type: 'Sprite',
      name: 'RewardContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'seasonpass_premium_reward_frame',
      parent: 'ca816ee2-2612-4e37-be37-74c40d43de14',
      data: ''
    },
    {
      id: '7caee9b9-40b4-4521-88cd-c56aea3bcb74',
      type: 'Container',
      name: 'RewardLock',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'ca816ee2-2612-4e37-be37-74c40d43de14',
      data: ''
    },
    {
      id: '6600a8de-a052-4715-bcf0-c95e1f5e75bb',
      type: 'Sprite',
      name: 'RewardLockIcon',
      nameSpace: '',
      className: '',
      x: 111,
      y: 104,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'icon_lock',
      parent: '7caee9b9-40b4-4521-88cd-c56aea3bcb74',
      data: ''
    },
    {
      id: '2e3d724a-3786-4804-b3ca-478c2c46ec65',
      type: 'NineSlicePlane',
      name: 'RewardTooltip',
      nameSpace: '',
      className: '',
      x: -34,
      y: 90,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 200,
      height: 100,
      leftWidth: 30,
      topHeight: 0,
      rightWidth: 30,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'seasonpass_tooltip_bubble',
      parent: 'ca816ee2-2612-4e37-be37-74c40d43de14',
      data: ''
    },
    {
      id: 'f62988a0-ceb7-4c7d-a06a-c25d0a76d139',
      type: 'Sprite',
      name: 'RewardIcon',
      nameSpace: '',
      className: '',
      x: 68,
      y: 50,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gas_can_reward',
      parent: 'da9c5f4d-9f68-4f25-89e5-3a0748a11718',
      data: ''
    },
    {
      id: '049996ce-75ae-4531-a95f-8ae1df34016f',
      type: 'Text',
      name: 'RewardText',
      nameSpace: '',
      className: '',
      x: 68,
      y: 90,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x2',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 22,
        fontWeight: 'normal',
        fontFamily: 'MyriadProBlack',
        fill: 'white',
        stroke: '#8d3321',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'da9c5f4d-9f68-4f25-89e5-3a0748a11718',
      data: ''
    },
    {
      id: 'e1645c54-a29a-4473-b114-21708e886c8f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 100,
      y: 25,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: -1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'seasonpass_tooltip_tail',
      parent: '2e3d724a-3786-4804-b3ca-478c2c46ec65',
      data: ''
    },
    {
      id: 'b7d281ba-5b9a-424e-b43e-4420d948331e',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 100,
      y: 50,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'SeasonPassTooltipLocked',
      localize: true,
      maxWidth: 170,
      maxHeight: 68,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 20,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#8d3321',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 170,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.3,
        dropShadowBlur: 2,
        dropShadowColor: '#ffffff',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '2e3d724a-3786-4804-b3ca-478c2c46ec65',
      data: ''
    },
    {
      id: '59ee2a92-3d10-415b-92e1-5b45cce4deb3',
      type: 'Container',
      name: 'RewardGlowContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'da9c5f4d-9f68-4f25-89e5-3a0748a11718',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class SeasonPassRewardPremium {
  static raw = raw;
  root: PIXI.Container
  RewardContainer: PIXI.Sprite
  RewardGlowContainer: PIXI.Container
  RewardIcon: PIXI.Sprite
  RewardText: PIXI.Text
  RewardLock: PIXI.Container
  RewardLockIcon: PIXI.Sprite
  RewardTooltip: PIXI.NineSlicePlane

  constructor() {
    populate(this, raw);
  }
}
